import { AngularEnvironment } from './angular-environment';

export const environment: AngularEnvironment = {
	name: 'DEV',
	appName: 'Devo',
	baseUrl: 'https://programs-dev.eforall.org/',
	bodyCssClasses: [],
	frame: 'Dashboard',
	supportsSpanish: false,
	functionUrl: "https://us-central1-eforall-devo-dev.cloudfunctions.net/",
	firebaseConfig: {
		apiKey: "AIzaSyDuSTR6Sxvwhip-UmTStHCYNza4V_cKVRA",
		authDomain: "eforall-devo-dev.firebaseapp.com",
		projectId: "eforall-devo-dev",
		storageBucket: "eforall-devo-dev.firebasestorage.app",
		messagingSenderId: "269672108338",
		appId: "1:269672108338:web:9e74a8f3b01eb86bc0072b",
		measurementId: "G-S7H55WF431"
	},
	algoliaConfig: {
		applicationId: 'IBESBT489G',
		apiKey: '69bbe063ee0e4d3664ac9ac7ffd0fc37',
		indexName: 'prod_PROGRAMS_APP'
	},
};
